import { call, put, takeLatest } from "redux-saga/effects";
import { FETCH_ADS, setAds } from "../actions/advertisement";
import { apiGet } from "acds-react-core";

function* fetchAdsSaga(action) {
  // Check session storage first
  const cachedAds = sessionStorage.getItem('cachedAds');
  if (cachedAds) {
    yield put(setAds(JSON.parse(cachedAds)));
    return;
  }

  try {
    const response = yield call(apiGet, "api/advertisements/");
    const ads = Array.isArray(response?.results) ? response.results : (Array.isArray(response) ? response : []);
    
    sessionStorage.setItem('cachedAds', JSON.stringify(ads));
    yield put(setAds(ads));
  } catch (error) {
    console.error("Ads fetch failed", error);
    yield put(setAds([]));
  }
}

export default function* advertisementSaga() {
  yield takeLatest(FETCH_ADS, fetchAdsSaga);
}
